var map = {
	"./icon-beach.png": 2985,
	"./icon-city.png": 2986,
	"./icon-desert.png": 2987,
	"./icon-fairyland.png": 2988,
	"./icon-farm.png": 2989,
	"./icon-forest.png": 2990,
	"./icon-jungle.png": 2991,
	"./icon-lake.png": 2992,
	"./icon-mushrooms.png": 2993,
	"./icon-savannah.png": 2994,
	"./icon-sky.png": 2995,
	"./icon-space.png": 2996,
	"./icon-tundra.png": 2997,
	"./icon-underwater.png": 2998
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 381;



//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-icons .\.png*
// module id = 381
// module chunks = 0